import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../actions';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.renderUsers = this.renderUsers.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
  }

  componentDidMount() {
    this.props.adminGetUsers();
  }

  renderUsers() {
    const { adminUsersToAdd, adminUsersToRemove } = this.props;
    if ([...adminUsersToAdd, ...adminUsersToRemove].length === 0) return null;

    const usersToAddRow = adminUsersToAdd.map(user => {
      const { email } = user;
      return (
        <li key={Math.random()}>{email}
          <span className="row-buttons" style={{float: 'right'}}>
          <Link to="" onClick={event => this.handleAddUser(event, email)}>Add</Link>
          </span>
        </li>
      )
    });

    const usersToRemoveRow = adminUsersToRemove.map(user => {
      const { email } = user;
      return (
        <li key={Math.random()}>{email}
          <span className="row-buttons" style={{float: 'right'}}>
            <Link to="" onClick={event => this.handleRemoveUser(event, email)}>Remove</Link>
          </span>
        </li>
      )
    });
  
    return [...usersToAddRow, ...usersToRemoveRow]
  }

  handleAddUser(event, email) {
    event.preventDefault();
    this.props.adminAddUser(email);
  }

  handleRemoveUser(event, email) {
    event.preventDefault();
    this.props.adminRemoveUser(email);
  }

  render() {
    return(
      <div className="row">
        <p className="col s12">Feature to bypass subscription to add full-access to user</p>
        <ul className="col s12">
          <li>Show users</li>
          <li>Option to give access, option to remove</li>
          <li>Modify table to include "special"</li>
          <li>Allow route access only if signed in as anthony.deguzm@gmail.com or email@anthonydeguzman.com</li>
        </ul>

      <ul className="col s4 offset-s4">
        {this.renderUsers()}
      </ul>
      </div>
    )
  }
}

function mapStateToProps({ adminUsers, adminUsersToAdd, adminUsersToRemove }) {
  return { adminUsers, adminUsersToAdd, adminUsersToRemove };
}

export default connect(mapStateToProps, actions)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js